// src/features/auth/authSlice.js

import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  token: localStorage.getItem('vendorAuthToken'),
  vendorData: JSON.parse(localStorage.getItem('vendorData') || "{}"),
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    login(state, action) {
        const data = action.payload;
        localStorage.setItem("vendorAuthToken", data.token);
        localStorage.setItem("vendorData", JSON.stringify(data.data));
        state.token = data.token;
        state.vendorData = data.data
      },
      logout(state) {
        localStorage.removeItem("vendorAuthToken");
        localStorage.removeItem("vendorData");
        state.token = '';
        state.vendorData = {}
    },
    setToken(state, action) {
      state.token = action.payload;
      localStorage.setItem("vendorAuthToken", action.payload);

    },
    clearToken(state) {
      state.token = null;
    },
    setVendorData(state, action) {
      state.vendorData = action.payload;
      localStorage.setItem("vendorData", JSON.stringify(action.payload));

    },
    clearVendorData(state) {
      state.vendorData = null;
    },
  },
});

export const { setToken, clearToken, setVendorData, clearVendorData, login, logout } = authSlice.actions;

export default authSlice.reducer;
